module.exports = __webpack_public_path__ + "img/no-wifi.d4998524.png";